module.exports = __webpack_public_path__ + "static/media/arrow-down-icon.b1421aa4.svg";